import { cn } from "@/lib/utils";

// Shimmer skeleton for loading states.
function Skeleton({ className, ...props }) {
  return (
    <div
      data-kit=""
      className={cn("relative overflow-hidden rounded-md bg-secondary", className)}
      {...props}
    >
      <div className="absolute inset-0 -translate-x-full animate-[shimmer_1.6s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
    </div>
  );
}

export { Skeleton };
